import React from 'react'

export const Increase = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">
  <path strokeWidth={"1px"} d="M13.5 0.5L7.85 6.95714C7.75654 7.06184 7.63088 7.12049 7.5 7.12049C7.36912 7.12049 7.24346 7.06184 7.15 6.95714L4.85 4.32857C4.75654 4.22387 4.63088 4.16522 4.5 4.16522C4.36912 4.16522 4.24346 4.22387 4.15 4.32857L0.5 8.5" stroke="#7CE13E" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  )
}
